import { Card, Center } from "@mantine/core";
import classes from "./CenteredCardPage.module.css";
import { NoanLogo } from "./icons/NoanLogo.svg";
import { PageMeta } from "./Page";

/**
 * Standalone card centered in the viewport, for small focused pages outside
 * the app shell (consent screens, email confirmations, ...).
 */
export function CenteredCardPage({
  title,
  description,
  footer,
  children,
}: React.PropsWithChildren<{
  title?: string;
  description?: string;
  footer?: React.ReactNode;
}>) {
  return (
    <div className={classes.pageContainer}>
      <PageMeta title={title} description={description} />
      <div className={classes.column}>
        <Center mb="xl">
          <NoanLogo width={100} />
        </Center>
        <Card py="xl" px="lg" className={classes.card}>
          {children}
        </Card>
        {footer != null && <div className={classes.footer}>{footer}</div>}
      </div>
    </div>
  );
}
